import React from 'react';
import { WebsiteDesignProps } from './types';
import { Briefcase, TrendingUp, Handshake } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ConsultingFirm: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Strategy Group";

    return (
        <div className="bg-[#f8f9fa] min-h-screen font-sans text-gray-800">
            <header className="bg-white shadow-sm sticky top-0 z-50">
                <div className="container mx-auto px-8 h-20 flex justify-between items-center">
                    <span className="text-2xl font-serif font-bold tracking-tight text-[#003366]">
                        {schoolName}
                    </span>
                    <nav className="hidden md:flex gap-8 text-sm font-semibold uppercase tracking-wider text-gray-500">
                        <a href="#" className="hover:text-[#003366] transition-colors">Expertise</a>
                        <a href="#" className="hover:text-[#003366] transition-colors">Industries</a>
                        <a href="#" className="hover:text-[#003366] transition-colors">Careers</a>
                        <a href="#" className="hover:text-[#003366] transition-colors">About Us</a>
                    </nav>
                    <Button variant="outline" className="border-[#003366] text-[#003366] hover:bg-[#003366] hover:text-white rounded-none uppercase text-xs font-bold tracking-widest px-6 transition-colors">
                        Contact
                    </Button>
                </div>
            </header>

            <section className="bg-white py-24 border-b border-gray-200">
                <div className="container mx-auto px-8 flex flex-col items-center text-center max-w-4xl">
                    <h1 className="text-5xl md:text-6xl font-serif font-medium text-[#003366] mb-8 leading-tight">
                        Transforming Potential <br/> Into Performance.
                    </h1>
                    <div className="w-24 h-1 bg-[#cc0000] mb-8"></div>
                    <p className="text-xl text-gray-600 mb-10 leading-relaxed max-w-2xl">
                        We provide rigorous educational frameworks that empower organizations to navigate complexity and achieve sustainable growth.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mt-12 text-left">
                         <div className="border-t-2 border-gray-200 pt-6">
                             <TrendingUp className="text-[#cc0000] mb-4" size={28} />
                             <h3 className="font-bold text-[#003366] text-lg mb-2">Growth Strategy</h3>
                             <p className="text-gray-500 text-sm">Identifying new avenues for value creation.</p>
                         </div>
                         <div className="border-t-2 border-gray-200 pt-6">
                             <Briefcase className="text-[#cc0000] mb-4" size={28} />
                             <h3 className="font-bold text-[#003366] text-lg mb-2">Operational Excellence</h3>
                             <p className="text-gray-500 text-sm">Optimizing processes for peak efficiency.</p>
                         </div>
                         <div className="border-t-2 border-gray-200 pt-6">
                             <Handshake className="text-[#cc0000] mb-4" size={28} />
                             <h3 className="font-bold text-[#003366] text-lg mb-2">Leadership Development</h3>
                             <p className="text-gray-500 text-sm">Training the next generation of executives.</p>
                         </div>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-[#003366] text-white">
                <div className="container mx-auto px-8 flex flex-col md:flex-row justify-between items-center">
                    <div>
                        <h2 className="text-3xl font-serif font-bold mb-2">Ready to reshape your future?</h2>
                        <p className="text-blue-200">Schedule a consultation with our senior partners.</p>
                    </div>
                    <Button className="mt-6 md:mt-0 bg-white text-[#003366] hover:bg-gray-100 rounded-none px-8 py-6 uppercase font-bold tracking-widest text-xs">
                        Get in Touch
                    </Button>
                </div>
            </section>
        </div>
    );
};

export default ConsultingFirm;
